function getFinancialNetworkData() {
    return ({
        'industry_outlook':{
                img:"https://media.deloitte.com/is/image/deloitte/us187423-fsi-outlooks-ins-banner:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=480&dpr=off",
                link: "https://www2.deloitte.com/us/en/insights/industry/financial-services/financial-services-industry-outlooks/insurance-industry-outlook.html",
                content: "2022 insurance industry outlook"
                },
        'market_outlook': {
                img:"https://media.deloitte.com/is/image/deloitte/us187527-fsi-outlooks-bcm-banner:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=481&dpr=off",
                link: "https://www2.deloitte.com/us/en/insights/industry/financial-services/financial-services-industry-outlooks/banking-industry-outlook.html",
                content: "2022 banking and capital markets outlook"
                },
        'banking_momentum': {
                img:"https://media.deloitte.com/is/image/deloitte/us134194_banner:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=480&dpr=off",
                link: "https://www2.deloitte.com/us/en/insights/industry/financial-services/digitalization-in-banking.html",
                content: "Building on the digital banking momentum"
                },
        'tax operations': {
                img:"https://www.deloitte.com/content/dam/insights/articles/2024/us154484_cfs_operate-to-transform/content-images/us154484-figure3.png",
                link: "https://www2.deloitte.com/us/en/insights/industry/financial-services/tax-operating-model-transformation.html",
                content: "Is it time to strategically transform tax operations?"
                },
        'friendshoring': {
                img:"https://media.deloitte.com/is/image/deloitte/us175188_banner:720-x-480?$Responsive$&fmt=webp&fit=stretch,1&wid=720&hei=480&dpr=off",
                link: "https://www2.deloitte.com/us/en/insights/industry/public-sector/government-trends/2022/reshoring-global-supply-chains.html",
                content: `Reshoring and "friendshoring" supply chains`
                },
        'data_points': {
                img:"https://www.deloitte.com/content/dam/insights/articles/2024/us164873_dim-data-points/content-images/us164873-economy.png",
                link: "https://www2.deloitte.com/us/en/insights/deloitte-insights-magazine/insights-data-points.html",
                content: "Data points: Bite-size insights from Deloitte research"
                },
        }
    )
}

export default getFinancialNetworkData;